import { computed, observable } from 'mobx';
import { ReleaseModel } from '../../../components/release';
import { ArtistSchema, ReleaseSchema, TagSchema, TrackSchema } from '../../../types/schema';
import { PaginationMeta } from '../../../types';

export class ReleasePageModel {
  @observable
  artistSlug: string;

  @observable
  releaseSlug: string;

  @observable
  isMissing = false;

  @observable
  loading: boolean;

  @observable
  isSingle: boolean;

  @observable
  artist: ArtistSchema;

  @observable
  releaseIdentity: string;

  @observable
  activeRelease: ReleaseSchema;

  @observable
  releases: Array<ReleaseSchema>;

  @observable
  otherReleases: Array<ReleaseSchema>;

  @observable
  tracks: Array<TrackSchema>;

  @observable
  releaseModels: { [releaseIdentity: string]: ReleaseModel } = {};

  @computed
  get selectedRelease() {
    if (this.releases) {
      return this.releases.find((release) => release.slug === this.releaseSlug);
    }
    return null;
  }
}
